<div fxLayout fxLayoutAlign="start center" fxLayoutGap="4px" class="block mb-6">
  <h3 class="nomargin" fxFlex>Sites</h3>
  <sbnb-button
    *ngIf="directDashboardService.sites?.length > 0"
    type="secondary"
    size="mini"
    (click)="directDashboardService.addSite()">
    Create a site
  </sbnb-button>
</div>

<ng-template #loadingSitesTemplate>
  <div fxLayout>
    <mat-spinner diameter="24"></mat-spinner>
  </div>
</ng-template>

<ng-container *ngIf="directDashboardService.loadingSites === false; else loadingSitesTemplate">
  <ng-container *ngIf="directDashboardService.sites?.length > 0">
    <div fxLayout fxLayoutGap="32px" fxHide.lt-md class="px-4 rules__rule-header">
      <div fxFlex="0 0 72px">Status</div>
      <div fxFlex>Site name</div>
      <div fxFlex>Site type</div>
      <div fxFlex="120px">Properties</div>
      <div fxFlex="0 0 40px"></div>
    </div>

    <a
      *ngFor="let site of directDashboardService.sites"
      fxLayout
      fxLayoutGap="32px"
      fxLayoutAlign="start center"
      class="rules__rule-container"
      [routerLink]="[site.route]">
      <span
        fxFlex="0 0 72px"
        class="badge text-center"
        [class.badge-lemon]="site.status !== 'Live'"
        [class.badge-grass]="site.status === 'Live'">
        {{ site.status }}
      </span>

      <span fxFlex class="rule__title ellipsis">{{ site.name }}</span>

      <span fxFlex fxHide.lt-md>{{ site.type }}</span>

      <div fxFlex="120px" fxLayoutAlign="start center" fxHide.lt-md>
        <sbnb-avatar-group [items]="site.properties" [itemsForLabel]="site.name"></sbnb-avatar-group>
      </div>

      <div fxFlex="0 0 40px">
        <sbnb-more-menu-trigger [matMenuTriggerFor]="actionsMenu" [suppressClick]="true"></sbnb-more-menu-trigger>

        <mat-menu #actionsMenu="matMenu">
          <button
            *ngIf="site.type === 'Self hosted'"
            mat-menu-item
            (click)="directDashboardService.renameSite(site.id)">
            <div fxLayoutAlign="start center">
              <img src="/assets/iconography/edit.svg" alt="Edit" style="margin-right: 6px" />
              <span>Rename</span>
            </div>
          </button>
          <button mat-menu-item (click)="directDashboardService.deleteSite(site.id)">
            <div fxLayoutAlign="start center">
              <img src="/assets/iconography/delete.svg" alt="Delete" style="margin-right: 6px" />
              <span>Delete site</span>
            </div>
          </button>
        </mat-menu>
      </div>
    </a>
  </ng-container>
</ng-container>
